
import DemographicCharts from "./DemographicCharts";
import DemographicInsights from "./DemographicInsights";

interface DemographicSegment {
  name: string;
  count: number;
  percentage: number;
  agreePercentage?: number;
}

interface DemographicTabProps {
  data: {
    category: string;
    segments: DemographicSegment[];
  };
  colors: string[];
}

const DemographicTab = ({ data, colors }: DemographicTabProps) => {
  if (!data || !data.segments || data.segments.length === 0) {
    return (
      <div className="py-4 text-center text-muted-foreground">
        No demographic data available for this category.
      </div>
    );
  }

  return (
    <>
      <DemographicCharts 
        segments={data.segments} 
        colors={colors} 
        category={data.category}
      />

      <DemographicInsights 
        segments={data.segments} 
        colors={colors}
      />
    </>
  );
};

export default DemographicTab;
